// Copyright (c) 2021, Picsa Advisory Services (Pty) Ltd. All rights reserved.

import React from 'react'
import PropTypes from 'prop-types'
import { Query } from 'react-apollo'

import {
  Spinner,
  Warning,
  SvgIcon,
  Table
} from '../../components'

import { ClientInvestmentPolicyTableRow } from './ClientInvestmentPolicyTableRow'

import { decodeBase64 } from '../../utils'

import { QUERY_CLIENTINVESTMENTPOLICIES } from '../../queries'


export const ClientInvestmentPolicies = ({ clientInvestmentId }) => (
  <Query
    query={QUERY_CLIENTINVESTMENTPOLICIES}
    variables={{
      clientInvestmentId: decodeBase64(clientInvestmentId),
      orderBy: '-activation_on'
    }}>
    {({ loading, error, data }) => {
      if (loading) {
        return <Spinner type='tail' />
      }

      if (error) {
        return <Warning>Failed to fetch client investment policies data</Warning>
      }

      const clientInvestmentPolicies = data.clientinvestmentpolicies.edges
      const tableColumns = ['Contributor', 'Contibutor Type', 'Amount', 'Status', 'Activation on', 'Deprecation on']

      if (clientInvestmentPolicies.length === 0) {
        return (
          <div className='slds-m-left_large'>
            <SvgIcon
              variant='utility'
              symbol='info'
              size='small'
              colour='light'
              className='slds-m-right_small'
            />
            No policy records to display
          </div>
        )
      }

      return (
        <Table
          columns={tableColumns}
          rows={clientInvestmentPolicies.length === 0
            ? <ClientInvestmentPolicyTableRow empty={true} numberOfColumns={tableColumns.length} />
            : clientInvestmentPolicies.map(({ node: policy }) => (
              <ClientInvestmentPolicyTableRow policy={policy} />
            ))
          }
          objectRows={true}
          noRowBorders={true}
          className="slds-max-medium-table_stacked-horizontal slds-no-row-hover"
        />
      )
    }}
  </Query>
)

ClientInvestmentPolicies.propTypes = {
  clientInvestmentId: PropTypes.string.isRequired
}



// WEBPACK FOOTER //
// ./src/components/client-investment-policies/index.js